import React, { useState } from 'react';
import * as Styled from '../styled';
import { useLocale } from 'locale';
import { BaseCarousel } from 'ds/components/carousels/base-carousel';
import BlogCard from 'components/blog-card';
import GlassesIcon from 'assets/svg/glasses.svg';
import { BlogCarouselProps, isEmpty, getDirection } from '../helper';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { noop } from 'lodash';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';

export const BlogSection: React.FC<BlogCarouselProps> = ({ articles, loading, onCarouselScroll = noop }) => {
  const { t } = useLocale();
  const [ slideIndex, setSlideIndex ] = useState(0);
  const carouselSectionNode = React.useRef<HTMLDivElement>(null);
  const mediaBreakpoint = useScreenBreakpoint();
  const isMobile = mediaBreakpoint <= 2;
  const onCarouselSlideChange = (idx: number) => {
    onCarouselScroll(getDirection(slideIndex, idx), isMobile);
    setSlideIndex(idx);
  };

  const [ sectionInView, setSectionInView ] = useState(false);
  useIntersectionObserver(([ entry ]) => {
    setSectionInView(entry.isIntersecting);
  }, [ carouselSectionNode ], { threshold: 1 });

  if (isEmpty(articles, loading)) return null;

  return (
    <Styled.Root ref={carouselSectionNode} data-auto="articles-carousel">
      <Styled.Header className="area__blog-header">
        <Styled.InfoWrapper>
          <GlassesIcon height={40} width={40} />
          <Styled.InfoBox>
            <Styled.Title data-auto="articles-carousel-title" weight="bold">{t('blog.search.carousel.title')}</Styled.Title>
            <Styled.SubTitle data-auto="articles-carousel-subtitle">{t('blog.search.carousel.subtitle')}</Styled.SubTitle>
          </Styled.InfoBox>
        </Styled.InfoWrapper>
      </Styled.Header>
      <BaseCarousel
        hideShadow
        entryContentDXOverride={24}
        hideControls={isMobile}
        onSlideIndexChange={onCarouselSlideChange}
        activeCarouselSlide={slideIndex}
      >
        {articles.map((el, k, arr) => (
          <BlogCard
            key={k}
            articleId={el.id}
            rootNode={carouselSectionNode}
            sectionInView={sectionInView}
            title={el.title}
            imageUrl={el.image}
            developerId={el.owner.id}
            developerName={el.owner.name}
            postUrl={el.link}
            withLeftMargin={k !== arr.length - 1}
          />
        ))}
      </BaseCarousel>
    </Styled.Root>
  );
};
